/**
 * ProductGrid Component - Grid layout for displaying multiple products
 */

import type React from 'react';

import type { Product } from '../../types';
import { ProductCard } from '../ProductCard/ProductCard';

import * as styles from './ProductGrid.css';

interface ProductGridProps {
  products: Product[];
}

export const ProductGrid: React.FC<ProductGridProps> = ({ products }) => {
  if (products.length === 0) {
    return (
      <div className={styles.emptyState}>
        <h2 className={styles.emptyStateTitle}>No products found</h2>
        <p className={styles.emptyStateText}>
          Try adjusting your filters or check back later for new items.
        </p>
      </div>
    );
  }

  return (
    <div className={styles.grid}>
      {products.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
};
